import { Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid } from '../../Common/Credentials.js';
import Footer from '../../Component/Footer.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';
import { FormikTextField } from '../../CommonComponents/FormField.js';
import { Spinner } from 'react-bootstrap';
import MasterService from '../MasterService.js';
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';
import TextfieldComponent from '../../Component/TextfieldComponent.jsx';


class NewCountry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      country: '',
      code: '',
      message: '',
      loader: false,
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onSubmit(values) {
    this.setState({ loader: true })
    let data = {
      name: this.state.country.toUpperCase(),
      code: this.state.code.toUpperCase()
    }
    MasterService.AddCountry(data).then(() =>
      this.props.navigate('/countries'))
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
        this.setState({ message: e.response.data.message, loader: false })
      })

  }

  componentDidMount() {

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }

  }


  validate(values) {

    let errors = {}

    if (!values.country || values.country === '') {
      errors.country = "Country is Required";
    }
    if (!values.code || values.code === '') {
      errors.code = "Code is Required";
    }
    return errors;
  }

  render() {
    let { id, country, code } = this.state;

    return (

      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
        <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Countries",path:"/countries"},{name:"Add Country",path:null}]}/>
          </div>
            <div className="UI-form-card">

              <Formik
                initialValues={{ id, country, code }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}>
                {({errors}) => (
                  <Form autoComplete="off">
                    <div className="form-row">

                      <fieldset className="col-md-3">
                        <TextfieldComponent className="form-control" type="text" name="country" label="Enter Country" onChange={(e) => this.setState({ country: e.target.value, message: '' })} error={errors?.country} required />
                      </fieldset>
                      <fieldset className="col-md-3">
                        <TextfieldComponent className="form-control" type="text" name="code" label="Enter Country Code" onChange={(e) => this.setState({ code: e.target.value, message: '' })} error={errors?.code} required/>
                      </fieldset>
                    </div>
                    <div className="tw-mt-2 col-md-12 text-red">{this.state.message}</div>
                    {this.state.loader === true ? <button className="UI-btn UI-btn-primary" disabled><Spinner animation="border" size="sm" />&nbsp;{"Saving"}</button> : <button className="UI-btn UI-btn-primary" type="submit">Save</button>}
                    <Link as="button" className="UI-btn UI-btn-outline ml-1" to={{ pathname: '/country' }} >Cancel</Link>

                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default withRouter(NewCountry)